<template>
  <div class="btn__wrapper">
    <btn-select
      v-for="answer in answers"
      @click.native.once="handleClick(answer.value)"
    ><img :src="answer.image"><span>{{ answer.text }}</span>
    </btn-select>
  </div>
</template>

<script>
import BtnSelect from '../common/BtnSelect'

export default {
  components: {
    'btn-select': BtnSelect
  },
  data () {
    return {
      answers: [
        {
          text: 'Excellent (700+)',
          value: 'excellent',
          image: require('../../assets/img/diagram_exellent.svg')
        },
        {
          text: 'Good (700-640)',
          value: 'good',
          image: require('../../assets/img/diagram_good.svg')
        },
        {
          text: 'Fair (640-560)',
          value: 'fair',
          image: require('../../assets/img/diagram_fair.svg')
        },
        {
          text: 'Poor (560)',
          value: 'poor',
          image: require('../../assets/img/diagram_poor.svg')
        }
      ]
    }
  },
  methods: {
    handleClick (value) {
      this.$emit('input', value)
    }
  }
}
</script>
